<!-- This example requires Tailwind CSS v2.0+ -->
<template>
    <div class="bg-gray-800 p-8 mb-10">
        <div class="max-w-7xl mx-auto">
            <div class="mt-2 md:flex md:items-center md:justify-between">
                <div class="flex-1 min-w-0">
                    <h2 class="text-2xl font-bold leading-7 text-white sm:text-3xl">{{pageTitle}}</h2>
                </div>

<!--                <div class="mt-4 flex-shrink-0 flex md:mt-0 md:ml-4">-->
<!--                    <button type="button"-->
<!--                            class="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-gray-600 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-indigo-500">-->
<!--                        Współpraca-->
<!--                    </button>-->
<!--                </div>-->

            </div>
        </div>
    </div>
</template>

<script>
import {ChevronLeftIcon, ChevronRightIcon} from '@heroicons/vue/solid'

export default {
    components: {
        ChevronLeftIcon,
        ChevronRightIcon,
    },
    props: ["pageTitle"],

}
</script>
